<template>
  <Teleport to="body">
    <projects-gallery-modal
      v-if="selectedSlide"
      v-model:open="modalOpen"
      :slide="selectedSlide"
    />
  </Teleport>

  <div
    ref="splide"
    class="main-slider splide splide__dark"
  >
    <div class="splide__track">
      <div class="splide__list">
        <div
          v-for="(slide, index) in data"
          :key="index"
          class="splide__slide"
        >
          <a
            :href="slide.buttonLink"
            class="gallery-item"
            aria-haspopup="true"
            @click.prevent="onSlideClick(slide)"
          >
            <img
              :src="slide.mainImage"
              :alt="slide.title || 'Gallery item'"
            >
            <div class="content">
              <h3 class="title">{{ slide.title }}</h3>
              <p class="description">{{ slide.description }}</p>
              <div class="btn-custom secondary">{{ slide.buttonText }}</div>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Splide from '@splidejs/splide';
import { setupSplide } from '../../../js/global';
import modal from './modal.vue';

export default {
  name: 'ProjectsGallery',
  components: {
    'projects-gallery-modal': modal,
  },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      selectedSlide: null,
      modalOpen: false,
    };
  },
  mounted() {
    this.initSlider();
  },
  methods: {
    initSlider() {
      const splideElement = this.$refs.splide;
      if (!splideElement) return;

      const slideCount = this.data.length;

      // Don't initialize if no slides
      if (slideCount === 0) return;

      const options = {
        type: 'loop',
        rewind: true,
        perPage: 3,
        perMove: 1,
        pagination: true,
        gap: 16,
        drag: true,
        arrows: false,
        autoplay: true,
        interval: 5000,
        breakpoints: {
          1530: {
            perPage: 2,
          },
          1220: {
            perPage: 1,
          },
          1024: {
            perPage: 2,
          },
          706: {
            perPage: 1,
          },
        },
      };

      this.mainSplide = new Splide(splideElement, options);
      setupSplide(this.mainSplide);
      this.mainSplide.mount();
    },
    onSlideClick(slide) {
      this.selectedSlide = slide;
      this.modalOpen = true;
    },
  },
};
</script>
